import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {PartnerProduct} from "../partner-product.model";

export class PartnerProductDgSearchResults extends GenericDgSearchResults {
  public results: PartnerProduct[];

  constructor(total: number, results: PartnerProduct[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

